export const SAVE_DATA = 'contactDetail/SAVE_DATA';
export const ADD_NOTE = 'contactDetail/ADD_NOTE';
export const SET_CAME_TO_DETAIL_FROM = 'contactDetail/SET_CAME_TO_DETAIL_FROM';
export const APPEND_ADDITONAL_DATA_TO_CONTACT = 'contactDetail/APPEND_ADDITONAL_DATA_TO_CONTACT';
export const RESET_DETAIL = 'contactDetail/RESET_DETAIL';
